import React from 'react'
import PropTypes from 'prop-types'
import DropdownListItems from './DropdownListItems'
import { dispatcher } from './DropdownDispatcher'
import { customEvent } from 'scripts/helpers/AppHelper'
import ReactDOM from 'react-dom'
const TOGGLE_CLASS = 'toggle-dropdown'

class DropdownList extends React.Component {
  wrapperRef = null
  listActive = false
  constructor(props) {
    super(props)
    this.updateDom = this.updateDom.bind(this)
  }

  toggleWithId = (e) => {
    customEvent(e)
    const {id} = this.props
    dispatcher.emit(TOGGLE_CLASS, {id})
  }

  updateDom(data) {
    const dom = ReactDOM.findDOMNode(this)
    if (data.hide || this.listActive) {
      dom.classList.remove('dropdown-active')
      this.listActive = false
    } else {
      dom.classList.add('dropdown-active')
      this.listActive = true
    }
  }

  componentDidMount() {
    dispatcher.on(TOGGLE_CLASS, this.updateDom)
    document.addEventListener('mouseup', this.handleClickOutside)
  }

  componentWillUnmount() {
    dispatcher.off(TOGGLE_CLASS, this.updateDom)
    document.removeEventListener('mouseup', this.handleClickOutside)
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node
  }

  handleClickOutside = (event) => {
    if (!this.wrapperRef.contains(event.target) && this.listActive) {
      dispatcher.emit(TOGGLE_CLASS, {hide: true, id: this.props.dropdown})
    }
  }

  render() {
    const {linkText, dropDownList, id, dropdown, className} = this.props
    return (
      <div id={id} className={`dropdown-wrapper ${className}`} ref={this.setWrapperRef}>
        <a href="javascript:;" className="dropdown-link" onClick={this.toggleWithId}>
          {linkText} <i className="icon-arrow-down dropdown-indicator"></i>
        </a>
        <DropdownListItems navList={dropDownList} id={id} dropdown={dropdown} toggleWithId={this.toggleWithId}/>
      </div>
    )
  }
}

DropdownList.propTypes = {
  id: PropTypes.string.isRequired,
  dropDownList: PropTypes.array.isRequired,
  dropdown: PropTypes.string,
  linkText: PropTypes.string.isRequired
}

export default DropdownList



// WEBPACK FOOTER //
// ./assets/js/helpers/DropdownList.jsx